module.exports = __webpack_public_path__ + "static/img/new_exercise_program_whiteboard.1178ccbb.svg";